import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setFinancialState } from 'Reducers/stock';
import { FINANCIAL_STATEMENTS_MENU, FINANCIAL_STATEMENTS_GUBN } from 'Constants';
import SubHead from 'Component/title/sub_head';
import Radio from 'Component/common/radio';
import FinancialStatementsChart from 'Component/chart/financial_statements';

const FinancialStatements = () => {

  const { financialState, financialStatements } = useSelector((state) => state.stock);
  const [data, setData] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    if (financialStatements) {
      const x1 = [];
      const y1 = [];
      const y2 = [];

      let list = [...financialStatements.financialStatements];

      if (list) {
        list.forEach(element => {
          if (element.QQYY) {
            x1.push(element.QQYY);
          }
          
          // NP : 이익률
          if (element.VAL) {
            if (financialState === 'NP') {
              y1.push(element.VAL.toFixed(2));
            } else {
              y1.push(element.VAL);
            }
          }
  
          if (element.DIFF) {
            y2.push(element.DIFF);
          }
        });
      }

      setData({
        x1: x1,
        y1: y1,
        y2: y2
      });
    } else {
      setData(null);
    }
  }, [financialState, financialStatements]);

  function changeTyp(item) {
    dispatch(setFinancialState(item.value));
  }

  function checked(item) {
    return financialState && item.value === financialState;
  }

	return (
    <div className="content7">
      <SubHead>
        <img src="/static/images/icon_heart2.svg" alt="" />
        <span>주요 재무제표 추이</span>
      </SubHead>
      <div className="cont chartarea">
        <Radio radios={FINANCIAL_STATEMENTS_MENU} selected={financialState} onChange={changeTyp} checked={checked} />
        <div className="chart chart1" style={{ display: 'block' }}>
          { data && financialState === 'SALES' &&
            <FinancialStatementsChart data={data} title={[FINANCIAL_STATEMENTS_GUBN[financialState].title1, FINANCIAL_STATEMENTS_GUBN[financialState].title2]} />
          }
          { data && financialState === 'OP' &&
            <FinancialStatementsChart data={data} title={[FINANCIAL_STATEMENTS_GUBN[financialState].title1, FINANCIAL_STATEMENTS_GUBN[financialState].title2]} />
          }
          { data && financialState === 'DEBT' &&
            <FinancialStatementsChart data={data} title={[FINANCIAL_STATEMENTS_GUBN[financialState].title1, FINANCIAL_STATEMENTS_GUBN[financialState].title2]} />
          }
          { data && financialState === 'NP' &&
            <FinancialStatementsChart data={data} title={[FINANCIAL_STATEMENTS_GUBN[financialState].title1, FINANCIAL_STATEMENTS_GUBN[financialState].title2]} gubn={financialState}/>
          }
        </div>
      </div>
    </div>
  );
}

export default FinancialStatements;
